import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpService, LocalStorageService, MessageService } from 'brainloper-ui';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-indicadores',
    templateUrl: './indicadores.component.html',
    styleUrls: ['./indicadores.component.scss'],
    standalone: false
})
export class IndicadoresComponent implements OnInit {


  @ViewChild('grafanaFrame') grafanaFrame!: ElementRef<HTMLIFrameElement>;
  @Input() dashBoardId: number;

  urlGrafana: SafeResourceUrl;
  private homeUrl: string = environment.urlGrafana;
  seccionActive: boolean = false;


  constructor(
    private sanitizer: DomSanitizer,
    private storage: LocalStorageService,
    private http: HttpService,
    private messagingService: MessageService
  ) { }

  async ngOnInit() {
    this.messagingService.openLoading("Cargando", "indicadores...");
    await this.createSession()
    setTimeout(() => {
      this.messagingService.closeLoading();
    }, 3000);
  }


  async createSession() {
    var response = await this.http.getDataBody<any>(EndpointDictionary.Grafana.CREATE_SESSION, null, true)
    if (response) {
      const url = `${EndpointDictionary.Grafana.GET_DASHBOARD.replace('{id}', this.dashBoardId.toString())}`;
      var dashboardResponse = await this.http.getDataBody<string>(url, null, true)
      if (dashboardResponse) {
        this.homeUrl = dashboardResponse;
      }
      this.seccionActive = true;
      this.urlGrafana = this.sanitizer.bypassSecurityTrustResourceUrl(this.homeUrl);
    }
  }
}